export class PractitionerServices {
  id: number;
  practitionerId: number;
  serviceData: string;
  active: boolean;
}
